import { lexicalAdminAxios, requireApiData, requireApiSuccess, type ApiEnvelope } from '@/features/lexicals/api/client'
import type { Taxonomy, TaxonomyTerm, TaxonomyTranslations } from '@/features/lexicals/passages/api/types'

export interface TaxonomyInput {
  code: string
  name: string
  description: string | null
  translations: TaxonomyTranslations
  selection_mode: 'single' | 'multiple'
}

export interface TaxonomyTermInput {
  parent_id: string | null
  code: string
  name: string
  description: string
  translations: TaxonomyTranslations
  position: number
}

export const taxonomiesApi = {
  async list(): Promise<Taxonomy[]> {
    const response = await lexicalAdminAxios.get<ApiEnvelope<Taxonomy[]>>('/taxonomies', { params: { page: 1, size: 100 } })
    return requireApiData(response.data, 'Không thể tải taxonomy.')
  },

  async create(payload: TaxonomyInput): Promise<Taxonomy> {
    const response = await lexicalAdminAxios.post<ApiEnvelope<Taxonomy>>('/taxonomies', payload)
    return requireApiData(response.data, 'Không thể tạo taxonomy.')
  },

  async update(id: string, payload: TaxonomyInput): Promise<Taxonomy> {
    const response = await lexicalAdminAxios.put<ApiEnvelope<Taxonomy>>(`/taxonomies/${id}`, payload)
    return requireApiData(response.data, 'Không thể cập nhật taxonomy.')
  },

  async remove(id: string): Promise<void> {
    const response = await lexicalAdminAxios.delete<ApiEnvelope<undefined>>(`/taxonomies/${id}`)
    requireApiSuccess(response.data, 'Không thể xóa taxonomy.')
  },

  async createTerm(taxonomyId: string, payload: TaxonomyTermInput): Promise<TaxonomyTerm> {
    const response = await lexicalAdminAxios.post<ApiEnvelope<TaxonomyTerm>>(`/taxonomies/${taxonomyId}/terms`, payload)
    return requireApiData(response.data, 'Không thể tạo taxonomy term.')
  },

  async updateTerm(id: string, payload: TaxonomyTermInput): Promise<TaxonomyTerm> {
    const response = await lexicalAdminAxios.put<ApiEnvelope<TaxonomyTerm>>(`/taxonomy-terms/${id}`, payload)
    return requireApiData(response.data, 'Không thể cập nhật taxonomy term.')
  },

  async removeTerm(id: string): Promise<void> {
    const response = await lexicalAdminAxios.delete<ApiEnvelope<undefined>>(`/taxonomy-terms/${id}`)
    requireApiSuccess(response.data, 'Không thể xóa taxonomy term.')
  },
}
